import { t } from "@lingui/macro";

export const GPT_TEXT_STYLES = [
  {
    id: "normal",
    getDisplayName: () => t`Normal`,
  },
  { id: "aggressive", getDisplayName: () => t`Aggressive` },
  { id: "engaging", getDisplayName: () => t`Engaging` },
  { id: "excited", getDisplayName: () => t`Excited` },
  { id: "friendly", getDisplayName: () => t`Friendly` },
  { id: "selling", getDisplayName: () => t`Selling` },
  { id: "forbes", getDisplayName: () => t`Forbes` },
  { id: "harvard_professor", getDisplayName: () => t`Harvard Professor` },
  { id: "joanne_rowling", getDisplayName: () => t`Joanne Rowling` },
  { id: "dostoevsky", getDisplayName: () => t`Dostoevsky` },
  { id: "master_of_metaphor", getDisplayName: () => t`Master of Metaphor` },
  { id: "yellow_press", getDisplayName: () => t`Yellow Press` },
  {
    id: "british_scientists",
    getDisplayName: () => t`British scientists conducted a study`,
  },
  { id: "cult_member", getDisplayName: () => t`Cult member` },
  { id: "wolf_of_wall_street", getDisplayName: () => t`Wolf of Wall Street` },
  { id: "passive_aggression", getDisplayName: () => t`Passive aggression` },
  { id: "golum", getDisplayName: () => t`Golum` },
  { id: "detective", getDisplayName: () => t`Detective` },
  { id: "pun", getDisplayName: () => t`Pun` },
  { id: "boomers", getDisplayName: () => t`Boomers` },
  { id: "intercepted", getDisplayName: () => t`Intercepted` },
  { id: "conspiracy_theory", getDisplayName: () => t`Conspiracy Theory` },
  { id: "cuban_dictator", getDisplayName: () => t`Cuban dictator` },
] as const;
